import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'db0008',
    ecrans: ['00-2']
});
